import { ShowDialog } from "../../react/components/Dialogs/BaseDialog";
import { SlideAiDialog } from "./SlideAiDialog";

export class SlideAiController {
    static ShowSlideAiDialog = slide => {
        ShowDialog(SlideAiDialog, { slide });
    }
}
